import WeightCompositeInput from "./WeightCompositeInput";

export default WeightCompositeInput;
